export enum IntegrationStatusTypes {
    None,
    Initiated,
    Completed,
    NeedsDetails
}